import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdKeyboardArrowRight } from 'react-icons/md';

const AddClass = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        idno: '',
        gender: '',
        class: '',
        section: '',
        subject: '',
        time: '',
        dob: '',
        email: '',
        phone: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
    };


    const handleReset = () => {
        setFormData({
            firstName: '',
            idno: '',
            gender: '',
            class: '',
            section: '',
            subject: '',
            time: '',
            dob: '',
            email: '',
            phone: '',
        });
    };

    return (
        <div className="">
            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl font-semibold mb-4 sm:mb-5 md:mb-6 text-center sm:text-left">
                Classes
            </h1>

            <nav className="text-gray-600 mb-4">
                <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl">
                    <li>
                        <Link to="/dashboard" className="hover:text-[#ffa404]">
                            Home
                        </Link>
                    </li>
                    <li className="text-[#ffa404]">
                        <MdKeyboardArrowRight size={25} />
                    </li>
                    <li className="text-[#ffa404]">
                        <Link to="/allclass" className="hover:text-[#ffa404]">
                            Add New Class
                        </Link>
                    </li>
                </ol>
            </nav>

            <div className="bg-white shadow-md rounded-lg p-6 mt-6 h-[70vh] sm:h-[60vh] md:h-[60vh] lg:h-[70vh] xl:h-[60vh]">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center sm:text-left">Add New Class Schedule</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Form fields */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {/* First Name */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Teacher  Name*</label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Last Name */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">ID No*</label>
                            <input
                                type="number"
                                name="idno"
                                value={formData.idno}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Gender */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Gender*</label>
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Class*</label>
                            <select
                                name="class"
                                value={formData.class}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            >
                                <option value="">Select Class</option>
                                <option value="I">I</option>
                                <option value="II">II</option>
                                <option value="III">III</option>
                                <option value="IV">IV</option>
                                <option value="V">V</option>
                                <option value="VI">VI</option>
                                <option value="VII">VII</option>
                                <option value="VIII">VIII</option>
                                <option value="IX">IX</option>
                                <option value="X">X</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Section*</label>
                            <select
                                name="section"
                                value={formData.section}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            >
                                <option value="">Select Section</option>

                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Subject*</label>
                            <select
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            >
                                <option value="">Select Subject</option>

                                <option value="telugu">Telugu</option>
                                <option value="hindi">Hindi</option>
                                <option value="english">English</option>
                                <option value="maths">Mathematics</option>
                                <option value="science">Science</option>
                                <option value="social_studies">Social Studies</option>
                                <option value="physics">Physics</option>
                                <option value="chemistry">Chemistry</option>
                                <option value="biology">Biology</option>
                                <option value="computer_science">Computer Science</option>
                                <option value="history">History</option>
                                <option value="geography">Geography</option>
                                <option value="economics">Economics</option>
                                <option value="civics">Civics</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Time*</label>
                            <input
                                type="time"
                                name="time"
                                value={formData.time}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>


                        {/* Date of Birth */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Date of Birth*</label>
                            <input
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* E-Mail */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">E-Mail*</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Phone*</label>
                            <input
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div>

                    </div>

                    <div className="flex flex-col sm:flex-row space-x-0 sm:space-x-4 mt-4">
                        <button
                            type="submit"
                            className="p-4 bg-[#ffa404] text-white rounded-md hover:bg-[#e89d02] flex items-center justify-center"
                        >
                            Save
                        </button>
                        <button
                            type="button"
                            onClick={handleReset}
                            className="p-4 bg-gray-300 text-black rounded-md hover:bg-gray-400 flex items-center justify-center mt-4 sm:mt-0"
                        >
                            Reset
                        </button>
                    </div>
                </form>
            </div>


        </div>

    );
};

export default AddClass;
